import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user.js'
import settings from './modules/setting.js'
import getters from './getters.js'

Vue.use(Vuex)

export default new Vuex.Store({
  // state: {
  // },
  // getters: {
  // },
  // mutations: {
  // },
  // actions: {
  // },
  modules: {
    user,
    settings
  },
  getters
})
